import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import auth from './auth/reducer';
import customerInvoice from './customerInvoice/reducer';
import scriptionPlan from './scriptionPlan/reducer';
const reducers = combineReducers({
  auth,
  customerInvoice,
  menu,
  settings,
  scriptionPlan,
});

export default reducers;